"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Lexer = void 0;
const uuid_1 = require("../../../#lib/uuid");
const syntax_exception_1 = require("../syntax/syntax-exception");
const rule_1 = require("./rule");
const token_1 = require("./token");
const token_type_1 = require("./token-type");
class Lexer {
    constructor() {
        this.rules = [
            new rule_1.Rule(/\(/, token_type_1.TokenType.RoundBracketLeft),
            new rule_1.Rule(/\)/, token_type_1.TokenType.RoundBracketRight),
            new rule_1.Rule(/\[/, token_type_1.TokenType.SquareBracketLeft),
            new rule_1.Rule(/]/, token_type_1.TokenType.SquareBracketRight),
            new rule_1.Rule(/,/, token_type_1.TokenType.Comma),
            new rule_1.Rule(/==/, token_type_1.TokenType.Equal),
            new rule_1.Rule(/!=/, token_type_1.TokenType.NotEqual),
            new rule_1.Rule(/<=/, token_type_1.TokenType.LessThanOrEqual),
            new rule_1.Rule(/</, token_type_1.TokenType.LessThan),
            new rule_1.Rule(/>=/, token_type_1.TokenType.GreaterThanOrEqual),
            new rule_1.Rule(/>/, token_type_1.TokenType.GreaterThan),
            new rule_1.Rule(/=~/, token_type_1.TokenType.Match),
            new rule_1.Rule(/!~/, token_type_1.TokenType.NotMatch),
            new rule_1.Rule(/@</, token_type_1.TokenType.Subset),
            new rule_1.Rule(/!@</, token_type_1.TokenType.NotSubset),
            new rule_1.Rule(/@>/, token_type_1.TokenType.Superset),
            new rule_1.Rule(/!@>/, token_type_1.TokenType.NotSuperset),
            new rule_1.Rule(/\bNOT\b/, token_type_1.TokenType.Not),
            new rule_1.Rule(/\bAND\b/, token_type_1.TokenType.And),
            new rule_1.Rule(/\bOR\b/, token_type_1.TokenType.Or),
            new rule_1.Rule(/"(?:\\.|[^"\\])*"/, token_type_1.TokenType.String),
            new rule_1.Rule(/\/(?:\\.|[^/\\])*\/[a-z]*/, token_type_1.TokenType.RegExp),
            new rule_1.Rule(/\b\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z)\b/, token_type_1.TokenType.Date),
            new rule_1.Rule(uuid_1.uuidMatcher, token_type_1.TokenType.Uuid),
            new rule_1.Rule(/\b(?:\d*\.)?\d+\b/, token_type_1.TokenType.Number),
            new rule_1.Rule(/\b(?:true|false)\b/, token_type_1.TokenType.Boolean),
            new rule_1.Rule(/\bnull\b/, token_type_1.TokenType.Null),
            new rule_1.Rule(/\b[a-zA-Z_](?:\.(?!\.)|\w)*\b/, token_type_1.TokenType.Identifier),
        ];
    }
    tokenize(expression) {
        const tokenString = [];
        let indexCurrent = 0;
        while (indexCurrent < expression.length) {
            // skip whitespace
            while (/\s/.test(expression[indexCurrent])) {
                indexCurrent++;
            }
            if (indexCurrent >= expression.length) {
                break; // skips trailing whitespaces
            }
            let foundToken = false;
            for (const rule of this.rules) {
                const token = rule.tryParse(expression.substr(indexCurrent));
                if (token === null) {
                    continue;
                }
                indexCurrent += token.value.length;
                tokenString.push(token);
                foundToken = true;
                break;
            }
            if (!foundToken) {
                const result = /\S+?\b/.exec(expression.substr(indexCurrent));
                throw new syntax_exception_1.SyntaxException(`Invalid token '${result[0]}' at ${indexCurrent}`);
            }
        }
        tokenString.push(new token_1.Token(token_type_1.TokenType.Eof, 'EOF'));
        return tokenString;
    }
}
exports.Lexer = Lexer;
//# sourceMappingURL=lexer.js.map